import styled from '@emotion/styled'
import css from '@styled-system/css'

import Box from './Box'

const Container = styled(Box)`
  ${css({
    maxWidth: 'containerWidth',
    mx: 'auto',
    my: 0,
    px: [3, 7, 3],
  })}
`

export default Container
